import { Skeleton } from "@/components/atoms";
import { StateRatesViewPanel, usePricingProfileContext, useStateRatesContext } from "@/components/organisms";
import { Restricted } from "@/components/pages/Restricted/Restricted";

export const StateRatesView = () => {
  const { isFetching: isFetchingPricingProfile, isRestricted: isRestrictedPricingProfile } = usePricingProfileContext();
  const { isFetching: isFetchingStateRates, isRestricted: isRestrictedStateRates, activeState: state } = useStateRatesContext();
  const isFetching = isFetchingPricingProfile || isFetchingStateRates;
  const isRestricted = isRestrictedPricingProfile || isRestrictedStateRates;

  if (isFetching) {
    return (
      <div className="flex min-h-[calc(100vh-120px)] flex-1 flex-col px-5 py-4">
        <Skeleton />
      </div>
    );
  }

  return (
    <div className="flex min-h-[calc(100vh-120px)] flex-1 flex-col px-5 py-4">
      {isRestricted ? <Restricted /> : state && <StateRatesViewPanel state={state} />}
    </div>
  );
};
